var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { leftSideTools, } from '../interface/gameController';
import { fetchData } from '../helper/helper';
import { NF_CELL_SIZE } from '../constants/gridConstants';
import { API_BASE_URL } from '../config/api';
import { v4 as uuidv4 } from 'uuid';
import { preloadAsBlob } from '../helper/imageBlobCache';
import { getPdfPageDimensions } from '../helper/pdfCache';
import { mergeWidget, mergeDicePoolEntries, entityToManipulative, manipulativeToSaveWidget, manipulativeToEntity, preloadTrayCounterSizes, preloadCounterBaseSizes, preloadImageSizes, } from './widgetMerger';
// Resolve the background PDF to render for a page given the active language.
// Non-English languages may supply their own per-page PDFs under
// `translations[<lang>].pages[<pageId>].background` (see initial.json). When a
// translated background exists for the current page it wins; otherwise we fall
// back to the page's default (English) background. The translated PDFs are
// localised versions of the same page, so widget positions and bgOffset (which
// are authored against the shared workspace) stay valid.
export function resolvePageBackground(page, language, translations) {
    var _a, _b, _c;
    var fallback = (_a = page === null || page === void 0 ? void 0 : page.background) !== null && _a !== void 0 ? _a : '';
    if (!page || !language || language === 'en' || !translations) {
        return fallback;
    }
    var langPages = (_b = translations[language]) === null || _b === void 0 ? void 0 : _b.pages;
    if (!langPages || !page.pageId) {
        return fallback;
    }
    return ((_c = langPages[page.pageId]) === null || _c === void 0 ? void 0 : _c.background) || fallback;
}
// Apply translation overrides to the raw initial JSON so downstream merges
// see localised face/card/counter images directly. Translations follow this
// schema (see also `resolvePageBackground` above for the background-only path):
//
//   translations.<lang> = {
//     pages:    { [pageId]: { background?, pageWidgets?: { [k]: <widget> } } },
//     widgets:  { [widgetId]: <widget config with translated face/card URLs> },
//     counters: { [counterId]: { frontImage, primaryImage, ... } },
//   }
//
// Lookup precedence per widget: page-level pageWidgets > global widgets.
// Tray counter images come straight from translations.<lang>.counters.
// English (or missing translations) returns the original payload unchanged.
export function applyTranslationOverrides(initial, language) {
    var _a, _b, _c, _d, _e, _f;
    if (!language || language === 'en' || !(initial === null || initial === void 0 ? void 0 : initial.translations))
        return initial;
    var trans = initial.translations[language];
    if (!trans || typeof trans !== 'object')
        return initial;
    var transCounters = (_a = trans.counters) !== null && _a !== void 0 ? _a : {};
    var transWidgetsGlobal = (_b = trans.widgets) !== null && _b !== void 0 ? _b : {};
    var transPages = (_c = trans.pages) !== null && _c !== void 0 ? _c : {};
    // Translate trayCounters (counter palette in the right-side tool panel).
    var newTrayCounters = ((_d = initial.trayCounters) !== null && _d !== void 0 ? _d : []).map(function (tc) {
        var t = transCounters[tc.counterId];
        if (!t)
            return tc;
        return __assign(__assign(__assign(__assign({}, tc), (typeof t.frontImage === 'string' && { frontImage: t.frontImage })), (typeof t.primaryImage === 'string' && { primaryImage: t.primaryImage })), (typeof t.backImage === 'string' && { backImage: t.backImage }));
    });
    // Per-page widget overrides. Translated `pageWidgets` is a keyed object
    // (e.g. {"1": {...}}), not an array, so we look up matches by widgetId.
    var newPages = {};
    var _loop_1 = function (pageId, page) {
        var transPage = transPages[pageId];
        var transPageWidgets = (_e = transPage === null || transPage === void 0 ? void 0 : transPage.pageWidgets) !== null && _e !== void 0 ? _e : {};
        var pageWidgetByWidgetId = new Map();
        for (var _j = 0, _k = Object.keys(transPageWidgets); _j < _k.length; _j++) {
            var key = _k[_j];
            var w = transPageWidgets[key];
            if (w === null || w === void 0 ? void 0 : w.widgetId)
                pageWidgetByWidgetId.set(w.widgetId, w);
        }
        var newPageWidgets = ((_f = page.pageWidgets) !== null && _f !== void 0 ? _f : []).map(function (pw) {
            var _a, _b, _c, _d;
            var override = (_a = pageWidgetByWidgetId.get(pw.widgetId)) !== null && _a !== void 0 ? _a : transWidgetsGlobal[pw.widgetId];
            if (!override)
                return pw;
            // Translated `data` is meant to mirror the original structure with
            // localised URLs — replace `data` wholesale rather than deep-merging,
            // so face arrays / card lists track the translation exactly.
            var mergedData = (_b = override.data) !== null && _b !== void 0 ? _b : pw.data;
            // Authored labels (e.g. deck labels): use the translated label when the
            // translation provides one (on `data.label` or a widget-level `label`),
            // otherwise keep the original so the wholesale `data` replace above never
            // drops it.
            var translatedLabel = (typeof ((_c = override.data) === null || _c === void 0 ? void 0 : _c.label) === 'string' && override.data.label) ||
                (typeof override.label === 'string' && override.label) ||
                undefined;
            var labelToUse = translatedLabel !== null && translatedLabel !== void 0 ? translatedLabel : (_d = pw.data) === null || _d === void 0 ? void 0 : _d.label;
            var dataWithLabel = mergedData && typeof labelToUse === 'string'
                ? __assign(__assign({}, mergedData), { label: labelToUse }) : mergedData;
            return __assign(__assign(__assign({}, pw), override), { data: dataWithLabel });
        });
        newPages[pageId] = __assign(__assign({}, page), { pageWidgets: newPageWidgets });
    };
    for (var _i = 0, _g = Object.entries(initial.pages); _i < _g.length; _i++) {
        var _h = _g[_i], pageId = _h[0], page = _h[1];
        _loop_1(pageId, page);
    }
    return __assign(__assign({}, initial), { pages: newPages, trayCounters: newTrayCounters });
}
var LocalDataSource = /** @class */ (function () {
    function LocalDataSource(initialUrl, productionUrl, userUrl) {
        if (initialUrl === void 0) { initialUrl = './json_files/initial.json'; }
        if (productionUrl === void 0) { productionUrl = './json_files/production.json'; }
        if (userUrl === void 0) { userUrl = './json_files/user.json'; }
        this.initialUrl = initialUrl;
        this.productionUrl = productionUrl;
        this.userUrl = userUrl;
    }
    LocalDataSource.prototype.fetchAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, initial, production, user;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            fetchData(this.initialUrl),
                            fetchData(this.productionUrl),
                            fetchData(this.userUrl).catch(function () { return null; }),
                        ])];
                    case 1:
                        _a = _b.sent(), initial = _a[0], production = _a[1], user = _a[2];
                        return [2 /*return*/, { initial: initial, production: production, user: user }];
                }
            });
        });
    };
    return LocalDataSource;
}());
export { LocalDataSource };
/**
 * Peel wrapper envelopes like `{ statusCode, status, data: {...} }` or a bare
 * `{ data: {...} }` down to the real payload. Stops once the current level
 * looks like a domain object (has `pages` or `save_state`) or no longer has a
 * single `data` handle to descend into.
 */
function unwrapPayload(payload) {
    var current = payload;
    for (var i = 0; i < 5; i++) {
        if (!current || typeof current !== 'object')
            return current;
        if ('pages' in current || 'save_state' in current)
            return current;
        if (current.data && typeof current.data === 'object') {
            current = current.data;
            continue;
        }
        return current;
    }
    return current;
}
/**
 * DataSource for IDM activities.
 * Fetches initial/production/user JSONs from backend endpoints using the
 * revision_id from `window.__IDM_MAPPING__`. If an endpoint returns 302 (e.g.
 * no user progress yet), the response is treated as an empty object so the
 * merge pipeline still runs.
 */
var IdmDataSource = /** @class */ (function () {
    function IdmDataSource(revisionId) {
        this.revisionId = revisionId;
    }
    IdmDataSource.prototype.fetchOrBlank = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch(url, { credentials: 'include', redirect: 'manual' })];
                    case 1:
                        res = _b.sent();
                        if (res.status === 302 || res.type === 'opaqueredirect')
                            return [2 /*return*/, {}];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        data = _b.sent();
                        if ((data === null || data === void 0 ? void 0 : data.statusCode) === 302)
                            return [2 /*return*/, {}];
                        return [2 /*return*/, unwrapPayload(data)];
                    case 3:
                        _a = _b.sent();
                        return [2 /*return*/, {}];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IdmDataSource.prototype.fetchAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, rawInitial, production, user, initial, r, workspaces, pages_1;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return __generator(this, function (_o) {
                switch (_o.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.fetchOrBlank("/initial-json/".concat(this.revisionId)),
                            this.fetchOrBlank("/production-json/".concat(this.revisionId)),
                            this.fetchOrBlank("/user-json/1/".concat(this.revisionId)),
                        ])];
                    case 1:
                        _a = _o.sent(), rawInitial = _a[0], production = _a[1], user = _a[2];
                        if (rawInitial && typeof rawInitial === 'object' && rawInitial.pages) {
                            r = rawInitial;
                            initial = __assign(__assign({}, r), { trayCounters: Array.isArray(r.trayCounters) ? r.trayCounters : [], translations: (_b = r.translations) !== null && _b !== void 0 ? _b : {} });
                        }
                        else {
                            workspaces = (_d = (_c = production === null || production === void 0 ? void 0 : production.save_state) === null || _c === void 0 ? void 0 : _c.workspaces) !== null && _d !== void 0 ? _d : [];
                            pages_1 = {};
                            workspaces.forEach(function (_, index) {
                                var pageId = "idm_page:".concat(index);
                                pages_1[pageId] = { pageId: pageId, background: '', pageWidgets: [] };
                            });
                            initial = {
                                title: (_g = (_e = rawInitial === null || rawInitial === void 0 ? void 0 : rawInitial.title) !== null && _e !== void 0 ? _e : (_f = production === null || production === void 0 ? void 0 : production.meta) === null || _f === void 0 ? void 0 : _f.appName) !== null && _g !== void 0 ? _g : 'IDM Activity',
                                activityId: (_h = rawInitial === null || rawInitial === void 0 ? void 0 : rawInitial.activityId) !== null && _h !== void 0 ? _h : String(this.revisionId),
                                basePath: (_j = rawInitial === null || rawInitial === void 0 ? void 0 : rawInitial.basePath) !== null && _j !== void 0 ? _j : '',
                                shareable: (_k = rawInitial === null || rawInitial === void 0 ? void 0 : rawInitial.shareable) !== null && _k !== void 0 ? _k : false,
                                pages: pages_1,
                                trayCounters: (_l = rawInitial === null || rawInitial === void 0 ? void 0 : rawInitial.trayCounters) !== null && _l !== void 0 ? _l : [],
                                translations: (_m = rawInitial === null || rawInitial === void 0 ? void 0 : rawInitial.translations) !== null && _m !== void 0 ? _m : {},
                            };
                        }
                        return [2 /*return*/, { initial: initial, production: production, user: user }];
                }
            });
        });
    };
    return IdmDataSource;
}());
export { IdmDataSource };
/**
 * DataSource for IDM activities that have a share-code snapshot layered on top.
 * Uses the IDM endpoints for `initial` + `production` (so background, widgets,
 * trayCounters etc. come from IDM), then replaces `user` with the share-code
 * JSON — treating the share code as the current user state, same way
 * `/user-json/1/:revisionId` would.
 *
 * FUTURE: if/when share codes that "belong to" an IDM are detected on their
 * own URL (i.e. no revision_id in the page), the app should redirect to the
 * IDM URL with the share code preserved as a query param so this combined
 * source is used instead of the pure ShareCodeDataSource.
 */
var IdmShareDataSource = /** @class */ (function () {
    function IdmShareDataSource(revisionId, shareCode, canvasSize) {
        if (canvasSize === void 0) { canvasSize = {
            canvasWidth: 5000,
            canvasHeight: 5000,
        }; }
        this.shareCode = shareCode;
        this.canvasSize = canvasSize;
        /**
         * True once `fetchAll` has run and the share code resolved to nothing, so the
         * activity's own baseline state was used instead.
         *
         * This used to be invisible: `fetchAll` fell back to `base.user` with no
         * signal, so a broken or mistyped code on a `/display-materials/<slug>?CODE`
         * link silently served the activity's default setup. A teacher sharing a work
         * place through an LMS saw students "only get some of the manipulatives" with
         * no error anywhere to explain it. `ShareCodeDataSource` already reported this
         * via its own `codeMissing`; the two are now read together in
         * `loadActivityData`.
         */
        this.codeMissing = false;
        /** Why the code failed, when `codeMissing` is true. Drives which notice the
         *  user sees — "no such code" and "sign in first" need different advice. */
        this.codeMissingReason = null;
        this.idm = new IdmDataSource(revisionId);
    }
    IdmShareDataSource.prototype.fetchAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, base, shareResult, shareUser;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.idm.fetchAll(),
                            fetchShareCodeResult(this.shareCode),
                        ])];
                    case 1:
                        _a = _b.sent(), base = _a[0], shareResult = _a[1];
                        shareUser = shareResult.status === 'ok' ? shareResult.data : null;
                        // Falling back to `base.user` is still the right behaviour — the activity
                        // itself is fine and should open — but record that the shared state was
                        // lost so the viewer can be told instead of quietly getting the default.
                        this.codeMissing = !shareUser;
                        this.codeMissingReason = shareResult.status === 'failed' ? shareResult.reason : null;
                        return [2 /*return*/, __assign(__assign({}, base), { user: shareUser ? stampCanvasDimensions(shareUser, this.canvasSize) : base.user })];
                }
            });
        });
    };
    return IdmShareDataSource;
}());
export { IdmShareDataSource };
/**
 * Share-code positions are stored in canvas-relative coordinates (origin 0,0
 * is the canvas origin). `mergePageData` computes a centering shift
 * `diffX/diffY` from the workspace dimensions vs the player canvas size and
 * adds it to every position. For share-code data we want that shift to be
 * zero — stamping the workspace dimensions to match the canvas size achieves
 * that without any branching inside the merge.
 */
function stampCanvasDimensions(data, canvasSize) {
    return __assign(__assign({}, data), { save_state: __assign(__assign({}, data.save_state), { workspaces: data.save_state.workspaces.map(function (w) {
                var _a;
                return (__assign(__assign({}, w), { 
                    // Only stamp when dimensions are missing — older share codes were
                    // saved without dimensions and with positions already in canvas coords
                    // (post-IDM-shift). Stamping to canvas size makes diffX/diffY zero so
                    // they render correctly. Newer saves include the original IDM page
                    // dimensions and positions in page-coords; preserving them lets the
                    // zoom-fit logic kick in just like the IDM flow.
                    dimensions: (_a = w.dimensions) !== null && _a !== void 0 ? _a : { width: canvasSize.canvasWidth, height: canvasSize.canvasHeight } }));
            }) }) });
}
/**
 * A blank save state — a single empty workspace. Used when a share-code record
 * exists but its `raw_json` is empty (`{}`): the code was created but nothing
 * has been saved into it yet, so the owner gets a blank canvas to draw and save
 * into instead of a load failure.
 */
function createBlankSaveState(meta) {
    return {
        save_state: {
            appState: { saveTime: Math.floor(Date.now() / 1000) },
            workspaces: [
                {
                    drawCommands: [],
                    shades: [],
                    texts: [],
                    annotations: [],
                    entities: [],
                    widgets: [],
                    zoomLevel: 100,
                },
            ],
        },
        meta: meta !== null && meta !== void 0 ? meta : {
            appName: '',
            schemaVersion: 'v1',
            username: '',
            activityUUID: '',
        },
    };
}
export function fetchShareCodeData(shareCode) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchShareCodeResult(shareCode)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.status === 'ok' ? result.data : null];
            }
        });
    });
}
/**
 * As `fetchShareCodeData`, but reports WHY the lookup failed. See
 * `ShareCodeFailureReason`.
 */
export function fetchShareCodeResult(shareCode) {
    return __awaiter(this, void 0, void 0, function () {
        var res, reason, body, candidate, hasSaveState, isShareCodeRecord, data, rawCreatedBy, createdBy, metaUrl, _a;
        var _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _j.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch("".concat(API_BASE_URL, "share-codes/").concat(encodeURIComponent(shareCode)), {
                            credentials: 'include',
                        })];
                case 1:
                    res = _j.sent();
                    if (!res.ok) {
                        reason = res.status === 401 || res.status === 403
                            ? 'unauthorized'
                            : res.status === 404
                                ? 'notFound'
                                : 'error';
                        return [2 /*return*/, { status: 'failed', reason: reason, httpStatus: res.status }];
                    }
                    return [4 /*yield*/, res.json().catch(function () { return null; })];
                case 2:
                    body = _j.sent();
                    candidate = (_e = (_d = (_c = (_b = body === null || body === void 0 ? void 0 : body.data) === null || _b === void 0 ? void 0 : _b.raw_json) !== null && _c !== void 0 ? _c : body === null || body === void 0 ? void 0 : body.raw_json) !== null && _d !== void 0 ? _d : body === null || body === void 0 ? void 0 : body.data) !== null && _e !== void 0 ? _e : body;
                    hasSaveState = !!(candidate && typeof candidate === 'object' && candidate.save_state);
                    isShareCodeRecord = !!((body === null || body === void 0 ? void 0 : body.data) && typeof body.data === 'object');
                    data = hasSaveState
                        ? candidate
                        : isShareCodeRecord
                            ? createBlankSaveState()
                            : null;
                    // `createdBy` (the share-code owner's user id) lives on the envelope/record,
                    // not inside the saved raw_json — surface it onto the returned data so
                    // callers can identify the owner. Coerce a numeric-string id to a number so
                    // it matches the numeric user id from /me.
                    if (data) {
                        rawCreatedBy = (_g = (_f = body === null || body === void 0 ? void 0 : body.data) === null || _f === void 0 ? void 0 : _f.createdBy) !== null && _g !== void 0 ? _g : body === null || body === void 0 ? void 0 : body.createdBy;
                        createdBy = typeof rawCreatedBy === 'number'
                            ? rawCreatedBy
                            : typeof rawCreatedBy === 'string' && rawCreatedBy.trim() !== '' && !isNaN(Number(rawCreatedBy))
                                ? Number(rawCreatedBy)
                                : undefined;
                        if (createdBy !== undefined)
                            data.createdBy = createdBy;
                    }
                    if (typeof window !== 'undefined' && data) {
                        metaUrl = (_h = data.meta) === null || _h === void 0 ? void 0 : _h.url;
                        if (metaUrl && metaUrl !== window.location.pathname) {
                            // Different activity than what's currently in the address bar —
                            // hard redirect to the correct path with the same share code. The
                            // navigation kicks in on the next event-loop tick; we still return
                            // the fetched data so any callers that synchronously inspect it
                            // before navigation don't crash on a null payload.
                            window.location.href = "".concat(window.location.origin).concat(metaUrl, "?").concat(shareCode);
                        }
                    }
                    // The server answered but carried no share-code record: the code is not
                    // there. Distinct from a transport failure, hence 'notFound' not 'error'.
                    if (!data)
                        return [2 /*return*/, { status: 'failed', reason: 'notFound', httpStatus: res.status }];
                    return [2 /*return*/, { status: 'ok', data: data }];
                case 3:
                    _a = _j.sent();
                    // Network failure / CORS / aborted — nothing was learned about the code.
                    return [2 /*return*/, { status: 'failed', reason: 'error' }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
/**
 * DataSource for shared activities loaded via share code.
 * The share code JSON contains only a save_state (like production/user).
 * A synthetic InitialJson is constructed with empty pages matching the workspace count.
 */
var ShareCodeDataSource = /** @class */ (function () {
    function ShareCodeDataSource(shareCode, canvasSize) {
        if (canvasSize === void 0) { canvasSize = {
            canvasWidth: 5000,
            canvasHeight: 5000,
        }; }
        this.shareCode = shareCode;
        this.canvasSize = canvasSize;
        /**
         * True once `fetchAll` has run and BOTH the backend and the dev
         * `json_files/` fallback came back empty — i.e. the share code in the URL
         * resolves to nothing and the blank-workspace fallback below was used.
         * `loadActivityData` reads this to tell the user their code doesn't exist
         * instead of silently handing them an empty canvas. Checking both sources
         * (not just `fetchShareCodeData`) is what keeps a local dev copy from
         * triggering a false "not found".
         */
        this.codeMissing = false;
        /** Why the backend lookup failed, when `codeMissing` is true. `null` when the
         *  code resolved, including via the dev `json_files/` copy. */
        this.codeMissingReason = null;
    }
    ShareCodeDataSource.prototype.fetchAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var backendResult, rawShareData, _a, safeShareData, shareData, workspaces, pages, initial;
            var _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, fetchShareCodeResult(this.shareCode)];
                    case 1:
                        backendResult = _g.sent();
                        if (!((_b = (backendResult.status === 'ok' ? backendResult.data : null)) !== null && _b !== void 0)) return [3 /*break*/, 2];
                        _a = _b;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, fetchData("./json_files/".concat(this.shareCode, ".json")).catch(function () { return null; })];
                    case 3:
                        _a = (_g.sent());
                        _g.label = 4;
                    case 4:
                        rawShareData = _a;
                        this.codeMissing = !rawShareData;
                        // Only meaningful when BOTH lookups failed — a dev copy resolving means the
                        // code is loadable and the backend reason is not something to report.
                        this.codeMissingReason =
                            this.codeMissing && backendResult.status === 'failed' ? backendResult.reason : null;
                        safeShareData = ((_c = rawShareData === null || rawShareData === void 0 ? void 0 : rawShareData.save_state) === null || _c === void 0 ? void 0 : _c.workspaces)
                            ? rawShareData
                            : createBlankSaveState((_d = rawShareData === null || rawShareData === void 0 ? void 0 : rawShareData.meta) !== null && _d !== void 0 ? _d : {
                                appName: '',
                                schemaVersion: 'v1',
                                username: '',
                                activityUUID: this.shareCode,
                            });
                        shareData = stampCanvasDimensions(safeShareData, this.canvasSize);
                        workspaces = shareData.save_state.workspaces;
                        pages = {};
                        workspaces.forEach(function (_, index) {
                            var pageId = "share_page:".concat(index);
                            pages[pageId] = {
                                pageId: pageId,
                                background: '',
                                pageWidgets: [],
                            };
                        });
                        initial = {
                            activityId: this.shareCode,
                            basePath: '',
                            shareable: true,
                            pages: pages,
                            trayCounters: [],
                            translations: {},
                            title: (_f = (_e = shareData.meta) === null || _e === void 0 ? void 0 : _e.appName) !== null && _f !== void 0 ? _f : '',
                        };
                        return [2 /*return*/, { initial: initial, production: shareData, user: null }];
                }
            });
        });
    };
    return ShareCodeDataSource;
}());
export { ShareCodeDataSource };
// ─── Per-page merge logic ───
export function mergePageData(initial, production, user, pageId, pageIndex, canvasSize, isShareCode, 
// Set on the language-switch re-merge so deck sizing is preserved from the
// initial load instead of being recomputed (which would inflate landscape
// decks on each switch).
preserveDimensions, 
// True for IDM/SWP activities — gates per-card image sizing + portrait decks.
isIdmOrSwp) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78;
    if (isShareCode === void 0) { isShareCode = false; }
    if (preserveDimensions === void 0) { preserveDimensions = false; }
    if (isIdmOrSwp === void 0) { isIdmOrSwp = false; }
    var initialPage = initial.pages[pageId];
    var prodWorkspace = production.save_state.workspaces[pageIndex];
    var userWorkspace = (_c = (_b = (_a = user === null || user === void 0 ? void 0 : user.save_state) === null || _a === void 0 ? void 0 : _a.workspaces) === null || _b === void 0 ? void 0 : _b[pageIndex]) !== null && _c !== void 0 ? _c : null;
    // Active workspace: user takes priority over production
    var activeWorkspace = userWorkspace !== null && userWorkspace !== void 0 ? userWorkspace : prodWorkspace;
    // Merge widgets: combine config from initial + position/state from active
    // workspace. Dice pool entries (roller / dice_pool) need special handling —
    // multiple saveWidget entries sharing one widgetId represent the per-die
    // saved state of the pool, not redundant copies of the whole pool. Batch
    // them by widgetId and hand to `mergeDicePoolEntries`, which decides whether
    // to expand a single placeholder or honour per-die saved centers.
    var widgets = [];
    if (activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.widgets) {
        var isDiceType = function (w) {
            return w.type === 'roller' || w.type === 'dice_pool';
        };
        var diceEntriesByWidgetId = new Map();
        for (var _i = 0, _79 = activeWorkspace.widgets; _i < _79.length; _i++) {
            var sw = _79[_i];
            if (!isDiceType(sw) || !sw.widgetId)
                continue;
            var list = (_d = diceEntriesByWidgetId.get(sw.widgetId)) !== null && _d !== void 0 ? _d : [];
            list.push(sw);
            diceEntriesByWidgetId.set(sw.widgetId, list);
        }
        var isDeckType_1 = function (w) {
            return w.type === 'picker' || w.type === 'deck' || w.type === 'deck_pool';
        };
        var processedDiceIds = new Set();
        // Deck-type widgets (picker/deck/deck_pool) can end up with more than one
        // saveWidget entry sharing the same widgetId (e.g. a stale entry left
        // over from an earlier save alongside the current one) — unlike dice,
        // there was no dedup here, so BOTH got merged and pushed, rendering two
        // overlapping copies of the same deck. Keep only the LAST occurrence per
        // widgetId (the most recently written entry in the save, mirroring
        // last-write-wins semantics) and drop any earlier stale duplicates.
        var lastDeckWidgetIndexById_1 = new Map();
        activeWorkspace.widgets.forEach(function (w, i) {
            if (isDeckType_1(w) && w.widgetId)
                lastDeckWidgetIndexById_1.set(w.widgetId, i);
        });
        var processedDeckIds = new Set();
        var _loop_2 = function (saveWidgetIndex) {
            var saveWidget = activeWorkspace.widgets[saveWidgetIndex];
            var initialWidget = (_e = initialPage === null || initialPage === void 0 ? void 0 : initialPage.pageWidgets) === null || _e === void 0 ? void 0 : _e.find(function (pw) { return pw.widgetId === saveWidget.widgetId; });
            // Production-load orphan filter: when not running from a share code, drop
            // saveWidgets that have no matching `initialWidget` config in initial.json.
            // Share codes are authoritative and may carry widgets with no initial
            // config, so they pass through; production loads only render widgets that
            // were actually authored.
            //
            // The filter is skipped when a user workspace is active: user-saved content
            // is authoritative (the user may have added widgets not in initial.json,
            // such as a deck added from the toolbar), and dropping those on a language
            // re-merge would silently erase user work.
            var isFromUserWorkspace = userWorkspace !== null;
            if (!isShareCode && !isFromUserWorkspace && !initialWidget) {
                console.warn('[mergePageData] dropping orphan production widget (no initial config):', saveWidget.widgetId, '| type:', saveWidget.type, '| pageId:', pageId, '| initial widgetIds on this page:', (_f = initialPage === null || initialPage === void 0 ? void 0 : initialPage.pageWidgets) === null || _f === void 0 ? void 0 : _f.map(function (pw) { return pw.widgetId; }));
                return "continue";
            }
            // Deck-specific orphan: the initialWidget exists but carries no cards
            // array, and the saveWidget also has no cards. That's a deck with no
            // content to render — drop it the same way as a missing-config widget.
            if (!isShareCode && !isFromUserWorkspace && isDeckType_1(saveWidget)) {
                var initialCards = (_g = initialWidget === null || initialWidget === void 0 ? void 0 : initialWidget.data) === null || _g === void 0 ? void 0 : _g.cards;
                var saveCards = (_h = saveWidget.data) === null || _h === void 0 ? void 0 : _h.cards;
                var hasInitialCards = Array.isArray(initialCards) && initialCards.length > 0;
                var hasSaveCards = Array.isArray(saveCards) && saveCards.length > 0;
                if (!hasInitialCards && !hasSaveCards) {
                    console.warn('[mergePageData] dropping orphan production deck (no cards in initial or save):', saveWidget.widgetId, '| type:', saveWidget.type);
                    return "continue";
                }
            }
            if (isDiceType(saveWidget) && saveWidget.widgetId) {
                if (processedDiceIds.has(saveWidget.widgetId))
                    return "continue";
                processedDiceIds.add(saveWidget.widgetId);
                var entries = (_j = diceEntriesByWidgetId.get(saveWidget.widgetId)) !== null && _j !== void 0 ? _j : [saveWidget];
                var produced = mergeDicePoolEntries(initialWidget, entries);
                widgets.push.apply(widgets, produced);
            }
            else {
                if (isDeckType_1(saveWidget) && saveWidget.widgetId) {
                    if (processedDeckIds.has(saveWidget.widgetId))
                        return "continue";
                    if (lastDeckWidgetIndexById_1.get(saveWidget.widgetId) !== saveWidgetIndex)
                        return "continue";
                    processedDeckIds.add(saveWidget.widgetId);
                }
                widgets.push.apply(widgets, mergeWidget(initialWidget, saveWidget, isShareCode, preserveDimensions, isIdmOrSwp));
            }
        };
        for (var saveWidgetIndex = 0; saveWidgetIndex < activeWorkspace.widgets.length; saveWidgetIndex++) {
            _loop_2(saveWidgetIndex);
        }
    }
    // Convert entities (counters on canvas) to manipulatives.
    // If an entity's counterId matches a card in a deck on this page, mark that card
    // as placed on the canvas instead of creating a separate counter manipulative.
    if (activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.entities) {
        var _loop_3 = function (entity) {
            // Share code entities: no counterId, already fully described widgets — pass through directly
            if (!entity.counterId) {
                // Clock entities: map share code fields to internal clockData format
                if (entity.type === 'clock') {
                    var d = entity.data;
                    var widgetId_1 = (_k = d === null || d === void 0 ? void 0 : d.id) !== null && _k !== void 0 ? _k : "analog_".concat(widgets.length);
                    widgets.push({
                        type: 'analog',
                        widgetId: widgetId_1,
                        data: {
                            id: widgetId_1,
                            type: 'analog',
                            analogType: (_l = d === null || d === void 0 ? void 0 : d.clockFace) !== null && _l !== void 0 ? _l : 'arabic',
                            movement: (d === null || d === void 0 ? void 0 : d.gearedMode) ? 'geared' : 'notgeared',
                            hourhandVisible: (_m = d === null || d === void 0 ? void 0 : d.showHourHand) !== null && _m !== void 0 ? _m : true,
                            minutehandVisible: (_o = d === null || d === void 0 ? void 0 : d.showMinuteHand) !== null && _o !== void 0 ? _o : true,
                            handLabelVisible: (_p = d === null || d === void 0 ? void 0 : d.showHandLabels) !== null && _p !== void 0 ? _p : false,
                            hour: 0,
                            minute: 0,
                            hourAngle: (((_r = (_q = d === null || d === void 0 ? void 0 : d.time) === null || _q === void 0 ? void 0 : _q.hourAngle) !== null && _r !== void 0 ? _r : 0) * 180) / Math.PI,
                            minuteAngle: (((_t = (_s = d === null || d === void 0 ? void 0 : d.time) === null || _s === void 0 ? void 0 : _s.minuteAngle) !== null && _t !== void 0 ? _t : 0) * 180) / Math.PI,
                            period: 'AM',
                            center: (d === null || d === void 0 ? void 0 : d.center) ? { x: d.center.x, y: d.center.y } : { x: 400, y: 400 },
                            dimensions: (d === null || d === void 0 ? void 0 : d.radius)
                                ? { width: d.radius * 2, height: d.radius * 2 }
                                : { width: 408, height: 408 },
                            scale: 1,
                            timer_minutes: 0,
                            timer_seconds: 0,
                            timerSetterVisible: false,
                            digitalClockVisible: (_u = d === null || d === void 0 ? void 0 : d.showDigitalDisplay) !== null && _u !== void 0 ? _u : false,
                            fractionOverlayParts: ((_w = (_v = d === null || d === void 0 ? void 0 : d.fractionDisplay) === null || _v === void 0 ? void 0 : _v.fragments) === null || _w === void 0 ? void 0 : _w.length) || null,
                            fractionOverlayColors: (_z = (_y = (_x = d === null || d === void 0 ? void 0 : d.fractionDisplay) === null || _x === void 0 ? void 0 : _x.fragments) === null || _y === void 0 ? void 0 : _y.map(function (f) { return f.color; })) !== null && _z !== void 0 ? _z : [],
                            fractionOverlayShadingEnabled: (_1 = (_0 = d === null || d === void 0 ? void 0 : d.fractionDisplay) === null || _0 === void 0 ? void 0 : _0.shown) !== null && _1 !== void 0 ? _1 : false,
                            fractionOverlayRotation: (_3 = (_2 = d === null || d === void 0 ? void 0 : d.fractionDisplay) === null || _2 === void 0 ? void 0 : _2.angle) !== null && _3 !== void 0 ? _3 : 0,
                            fractionDisplay: {
                                angle: (_5 = (_4 = d === null || d === void 0 ? void 0 : d.fractionDisplay) === null || _4 === void 0 ? void 0 : _4.angle) !== null && _5 !== void 0 ? _5 : 0,
                                fragments: (_7 = (_6 = d === null || d === void 0 ? void 0 : d.fractionDisplay) === null || _6 === void 0 ? void 0 : _6.fragments) !== null && _7 !== void 0 ? _7 : [],
                                shown: (_9 = (_8 = d === null || d === void 0 ? void 0 : d.fractionDisplay) === null || _8 === void 0 ? void 0 : _8.shown) !== null && _9 !== void 0 ? _9 : false,
                            },
                            runJumpVisible: (_11 = (_10 = d === null || d === void 0 ? void 0 : d.runJumpDisplay) === null || _10 === void 0 ? void 0 : _10.shown) !== null && _11 !== void 0 ? _11 : false,
                            runJumpTab: (_13 = (_12 = d === null || d === void 0 ? void 0 : d.runJumpDisplay) === null || _12 === void 0 ? void 0 : _12.activeTab) !== null && _13 !== void 0 ? _13 : 'jump',
                            elapsedTimeDisplay: {
                                shown: (_15 = (_14 = d === null || d === void 0 ? void 0 : d.elapsedTimeDisplay) === null || _14 === void 0 ? void 0 : _14.shown) !== null && _15 !== void 0 ? _15 : false,
                                active: (_17 = (_16 = d === null || d === void 0 ? void 0 : d.elapsedTimeDisplay) === null || _16 === void 0 ? void 0 : _16.active) !== null && _17 !== void 0 ? _17 : false,
                                startTime: {
                                    hourAngle: (_20 = (_19 = (_18 = d === null || d === void 0 ? void 0 : d.elapsedTimeDisplay) === null || _18 === void 0 ? void 0 : _18.startTime) === null || _19 === void 0 ? void 0 : _19.hourAngle) !== null && _20 !== void 0 ? _20 : 0,
                                    minuteAngle: (_23 = (_22 = (_21 = d === null || d === void 0 ? void 0 : d.elapsedTimeDisplay) === null || _21 === void 0 ? void 0 : _21.startTime) === null || _22 === void 0 ? void 0 : _22.minuteAngle) !== null && _23 !== void 0 ? _23 : 0,
                                    secondAngle: (_26 = (_25 = (_24 = d === null || d === void 0 ? void 0 : d.elapsedTimeDisplay) === null || _24 === void 0 ? void 0 : _24.startTime) === null || _25 === void 0 ? void 0 : _25.secondAngle) !== null && _26 !== void 0 ? _26 : 0,
                                },
                                endTime: {
                                    hourAngle: (_29 = (_28 = (_27 = d === null || d === void 0 ? void 0 : d.elapsedTimeDisplay) === null || _27 === void 0 ? void 0 : _27.endTime) === null || _28 === void 0 ? void 0 : _28.hourAngle) !== null && _29 !== void 0 ? _29 : 0,
                                    minuteAngle: (_32 = (_31 = (_30 = d === null || d === void 0 ? void 0 : d.elapsedTimeDisplay) === null || _30 === void 0 ? void 0 : _30.endTime) === null || _31 === void 0 ? void 0 : _31.minuteAngle) !== null && _32 !== void 0 ? _32 : 0,
                                    secondAngle: (_35 = (_34 = (_33 = d === null || d === void 0 ? void 0 : d.elapsedTimeDisplay) === null || _33 === void 0 ? void 0 : _33.endTime) === null || _34 === void 0 ? void 0 : _34.secondAngle) !== null && _35 !== void 0 ? _35 : 0,
                                },
                                dragStarted: false,
                                hoursCount: 0,
                                referenceAngle: null,
                                prevHourAngle: null,
                                totalMinuteAngle: null,
                                fraction: 0,
                            },
                            lock: { positioning: false, editing: false },
                        },
                    });
                    return "continue";
                }
                // Shape entities: map share code shape to internal patternShapes
                if (entity.type === 'shape') {
                    var d = (_36 = entity.data) !== null && _36 !== void 0 ? _36 : {};
                    var widgetId_2 = (_37 = d.id) !== null && _37 !== void 0 ? _37 : "patternShapes:".concat(uuidv4().replace(/-/g, ''));
                    var dataId = "patternShapes_".concat(uuidv4().replace(/-/g, ''));
                    var shapeTypeMap = {
                        square: 'square',
                        hexagon: 'hexagon',
                        trapezoid: 'trapezoid',
                        rhombus_blue: 'rhombus_blue',
                        rhombus_white: 'rhombus_white',
                        triangle: 'triangle_equilateral',
                        triangle_equilateral: 'triangle_equilateral',
                        triangle_right: 'triangle_right',
                        outline: 'outline',
                    };
                    var shapeType = (_38 = shapeTypeMap[d.type]) !== null && _38 !== void 0 ? _38 : 'square';
                    var colorKey = typeof d.color === 'string' ? d.color.toUpperCase() : 'BLUE';
                    widgets.push({
                        type: 'patternShapes',
                        widgetId: widgetId_2,
                        data: {
                            id: dataId,
                            type: 'patternShapes',
                            shapeType: shapeType,
                            center: d.center ? { x: d.center.x, y: d.center.y } : { x: 400, y: 400 },
                            rotation: (_39 = d.rotation) !== null && _39 !== void 0 ? _39 : 0,
                            scale: d.halfSize ? 0.5 : ((_40 = d.scale) !== null && _40 !== void 0 ? _40 : 1),
                            color: colorKey,
                            lock: (_41 = d.lock) !== null && _41 !== void 0 ? _41 : { positioning: false, editing: false },
                        },
                    });
                    return "continue";
                }
                // Frame entities: map share code fields to internal numberFrames format
                if (entity.type === 'frame') {
                    var d = (_42 = entity.data) !== null && _42 !== void 0 ? _42 : {};
                    var widgetId_3 = (_43 = d.id) !== null && _43 !== void 0 ? _43 : "numberFrames_".concat(widgets.length);
                    var cols = (_45 = (_44 = d.cellCount) === null || _44 === void 0 ? void 0 : _44.width) !== null && _45 !== void 0 ? _45 : 1;
                    var rows = (_47 = (_46 = d.cellCount) === null || _46 === void 0 ? void 0 : _46.height) !== null && _47 !== void 0 ? _47 : 1;
                    var presetKey = "".concat(cols, "x").concat(rows);
                    var frameType = presetKey === '5x1'
                        ? '5'
                        : presetKey === '5x2'
                            ? '10'
                            : presetKey === '10x2'
                                ? '20'
                                : presetKey === '10x10'
                                    ? '100'
                                    : 'custom';
                    var dimensions = { width: cols * NF_CELL_SIZE, height: rows * NF_CELL_SIZE };
                    widgets.push({
                        type: 'numberFrames',
                        widgetId: widgetId_3,
                        data: {
                            id: widgetId_3,
                            type: 'numberFrames',
                            frameType: frameType,
                            rows: rows,
                            cols: cols,
                            center: d.center ? { x: d.center.x, y: d.center.y } : { x: 400, y: 400 },
                            dimensions: dimensions,
                            defaultDimensions: dimensions,
                            scale: 1,
                            rotation: (((_48 = d.orientation) !== null && _48 !== void 0 ? _48 : 0) % 4) * 90,
                            show5x5Grid: false,
                            tokens: {},
                            lock: { positioning: false, editing: false },
                        },
                    });
                    return "continue";
                }
                var entityType = entity.type;
                var widgetId = (_50 = (_49 = entity.data) === null || _49 === void 0 ? void 0 : _49.id) !== null && _50 !== void 0 ? _50 : "".concat(entityType, "_").concat(widgets.length);
                var baseData = __assign(__assign({}, entity.data), { id: widgetId, type: entityType, lock: (_52 = (_51 = entity.data) === null || _51 === void 0 ? void 0 : _51.lock) !== null && _52 !== void 0 ? _52 : { positioning: false, editing: false } });
                if (entityType === 'counter') {
                    baseData.dimensions = (_54 = (_53 = entity.data) === null || _53 === void 0 ? void 0 : _53.dimensions) !== null && _54 !== void 0 ? _54 : { width: 50, height: 50 };
                    baseData.defaultDimensions = (_56 = (_55 = entity.data) === null || _55 === void 0 ? void 0 : _55.defaultDimensions) !== null && _56 !== void 0 ? _56 : { width: 50, height: 50 };
                    baseData.scale = (_58 = (_57 = entity.data) === null || _57 === void 0 ? void 0 : _57.scale) !== null && _58 !== void 0 ? _58 : 1;
                }
                widgets.push({ type: entityType, widgetId: widgetId, data: baseData });
                return "continue";
            }
            // IDM entities: match against deck cards or create counter
            var matchedCard = null;
            for (var _94 = 0, widgets_7 = widgets; _94 < widgets_7.length; _94++) {
                var widget = widgets_7[_94];
                if (widget.type !== 'deck_pool')
                    continue;
                var deckData = widget.data;
                if (!Array.isArray(deckData === null || deckData === void 0 ? void 0 : deckData.cards))
                    continue;
                var card = deckData.cards.find(function (c) { return c.counterId === entity.counterId && !c.placedOnDeck; });
                if (card) {
                    matchedCard = card;
                    break;
                }
            }
            if (matchedCard) {
                matchedCard.placedOnDeck = true;
                matchedCard.position = {
                    x: entity.data.position.x,
                    y: entity.data.position.y,
                };
                matchedCard.showImage = 'front';
            }
            else if (!(activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.hideTrayCounter)) {
                var m = entityToManipulative(entity, initial.trayCounters);
                if (m.type === 'counter' && !m.data.customImage)
                    return "continue";
                widgets.push(m);
            }
        };
        for (var _80 = 0, _81 = activeWorkspace.entities; _80 < _81.length; _80++) {
            var entity = _81[_80];
            _loop_3(entity);
        }
    }
    // ── Production-only: hide a fully-dealt deck ───────────────────────────────
    // When loading from production JSON (never share code), a deck whose cards are
    // ALL already dealt onto the page carries no remaining pile — the author meant
    // for just the loose cards to show, not an empty deck graphic. Flag it once
    // here so the deck renderer suppresses the pile while keeping the cards as-is.
    // This is a load-time decision only: it is never recomputed at runtime, so a
    // deck a user empties by hand still shows the normal empty-deck graphic. Share
    // code is user-generated content and is left untouched.
    if (!isShareCode) {
        for (var _82 = 0, widgets_1 = widgets; _82 < widgets_1.length; _82++) {
            var widget = widgets_1[_82];
            if (widget.type !== 'deck_pool')
                continue;
            var data = widget.data;
            var cards = data === null || data === void 0 ? void 0 : data.cards;
            if (!Array.isArray(cards) || cards.length === 0)
                continue;
            var placed = cards.filter(function (c) { return c.placedOnDeck; }).length;
            var allDealt = placed === cards.length;
            // if (allDealt) data.hideEmptyDeck = true;
            console.debug("[mergePageData] deck \"".concat((_59 = data === null || data === void 0 ? void 0 : data.label) !== null && _59 !== void 0 ? _59 : data === null || data === void 0 ? void 0 : data.id, "\" (").concat(widget.widgetId, "): ") +
                "".concat(placed, "/").concat(cards.length, " cards dealt \u2192 ").concat(allDealt ? 'HIDE deck pile' : 'keep deck'));
        }
    }
    // Center manipulatives: offset positions so JSON content is centered in the player viewport.
    // The shift uses the *active* workspace dimensions because those match the
    // coordinate system the saved positions were authored in. The page
    // dimensions exposed via bgOffset (used for background sizing + fit-zoom)
    // come from the production workspace when present so an IDM activity with
    // a share-code overlay still fits to the IDM page, not to the share-code's
    // (often canvas-stamped) workspace.
    // Fall back to canvas size when no dimensions are saved so diffX/diffY stay
    // zero (canvas-relative coords, no centering shift needed).
    var jsonPageWidth = (_61 = (_60 = activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.dimensions) === null || _60 === void 0 ? void 0 : _60.width) !== null && _61 !== void 0 ? _61 : canvasSize.canvasWidth;
    var jsonPageHeight = (_63 = (_62 = activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.dimensions) === null || _62 === void 0 ? void 0 : _62.height) !== null && _63 !== void 0 ? _63 : canvasSize.canvasHeight;
    var playerWidth = canvasSize.canvasWidth;
    var playerHeight = canvasSize.canvasHeight;
    // ── Workspace-centered translation ─────────────────────────────────────────
    // Saved widget positions are in workspace coordinates ([0, coordWidth] ×
    // [0, coordHeight]). The workspace box is centered in the canvas, so the
    // transform is a pure translation:
    //   canvas_x = saved_x + diffX,  diffX = (canvasWidth − coordWidth) / 2
    //   canvas_y = saved_y + diffY,  diffY = (canvasHeight − coordHeight) / 2
    var scaleX = 1;
    var scaleY = 1;
    var bgFile = initialPage === null || initialPage === void 0 ? void 0 : initialPage.background;
    var pdfDimsForLog = !isShareCode && bgFile && /\.pdf(\?|$)/i.test(bgFile)
        ? getPdfPageDimensions(bgFile)
        : undefined;
    var effectivePageWidth = (_64 = pdfDimsForLog === null || pdfDimsForLog === void 0 ? void 0 : pdfDimsForLog.width) !== null && _64 !== void 0 ? _64 : jsonPageWidth;
    var effectivePageHeight = (_65 = pdfDimsForLog === null || pdfDimsForLog === void 0 ? void 0 : pdfDimsForLog.height) !== null && _65 !== void 0 ? _65 : jsonPageHeight;
    var diffX = (playerWidth - jsonPageWidth) / 2;
    var diffY = (playerHeight - jsonPageHeight) / 2;
    // ── Production-only out-of-page filter ─────────────────────────────────────
    // When loading from production JSON (isShareCode = false), drop any item
    // whose anchor falls entirely outside the authored page rectangle. This
    // prevents off-screen artefacts that were placed during earlier authoring
    // sessions at a different canvas or page size from silently accumulating.
    //
    // Conditions for the filter to be active:
    //  1. Not a share-code load — share-code JSON is user-generated content that
    //     we should never silently discard.
    //  2. The production workspace carries explicit page dimensions. When none are
    //     saved the dimensions default to canvasSize, which is a placeholder, not
    //     a real page boundary — filtering against it would drop everything.
    //
    // After diffX/diffY are applied, the authored page rectangle in canvas coords:
    //   X: [diffX, diffX + jsonPageWidth]
    //   Y: [diffY, diffY + jsonPageHeight]
    var hasProdDimensions = !!(((_66 = prodWorkspace === null || prodWorkspace === void 0 ? void 0 : prodWorkspace.dimensions) === null || _66 === void 0 ? void 0 : _66.width) && ((_67 = prodWorkspace === null || prodWorkspace === void 0 ? void 0 : prodWorkspace.dimensions) === null || _67 === void 0 ? void 0 : _67.height));
    // `!userWorkspace` because the clip is a PRODUCTION import filter: an authored
    // page may carry widgets parked outside its own rectangle, and rendering those
    // is wrong. User-saved state is different — the user deliberately dragged an
    // item into the canvas margin, `extractUserSaveState` stores it there
    // faithfully, and clipping it on reload deletes their work with no warning.
    // `shouldClipShades` below already carried this guard; the other five clip
    // sites did not, which stayed invisible only because the sole non-share-code
    // source of a user workspace was the rarely-populated `/user-json` endpoint.
    // The localStorage unsaved-work draft (src/helper/unsavedDraft.ts) is now a
    // second, common one, so the guard belongs on the shared flag.
    var shouldClipToPage = !isShareCode && hasProdDimensions && !userWorkspace;
    // Clip against the workspace rectangle (the coord system widgets are
    // authored in), not the PDF — the PDF may be smaller than the workspace
    // and using it would silently drop widgets that are inside the workspace
    // but outside the PDF area.
    var pageLeft = diffX;
    var pageTop = diffY;
    var pageRight = diffX + jsonPageWidth;
    var pageBottom = diffY + jsonPageHeight;
    /** Returns true when the canvas-coordinate anchor (x, y) lies within the page. */
    var anchorInPage = function (x, y) {
        return x >= pageLeft && x <= pageRight && y >= pageTop && y <= pageBottom;
    };
    /** Apply page-to-canvas transform: canvas = saved * scale + diff. */
    var transformPoint = function (p) { return (__assign(__assign({}, p), { x: p.x * scaleX + diffX, y: p.y * scaleY + diffY })); };
    for (var _83 = 0, widgets_2 = widgets; _83 < widgets_2.length; _83++) {
        var widget = widgets_2[_83];
        var data = widget.data;
        if (data === null || data === void 0 ? void 0 : data.center) {
            data.center = transformPoint(data.center);
        }
        if (data === null || data === void 0 ? void 0 : data.groupCenter)
            data.groupCenter = transformPoint(data.groupCenter);
        // Deck cards dealt onto the canvas carry absolute positions — transform them too
        if (Array.isArray(data === null || data === void 0 ? void 0 : data.cards)) {
            for (var _84 = 0, _85 = data.cards; _84 < _85.length; _84++) {
                var card = _85[_84];
                if (card.placedOnDeck && card.position) {
                    card.position = transformPoint(card.position);
                }
            }
        }
    }
    // Filter widgets whose center falls outside the page (production only).
    if (shouldClipToPage) {
        var keep = widgets.filter(function (w) {
            var _a;
            var d = w.data;
            // Items without a center (shouldn't occur in practice) are kept.
            if (!(d === null || d === void 0 ? void 0 : d.center))
                return true;
            // Grouped pieces (e.g. expanded dice pools) are anchored together and
            // re-laid-out by ManipulativeGroup. Their individual centers are spread
            // across a grid, so judging each one against the page would drop the
            // outer members of an on-page group. Anchor the check on the shared
            // `groupCenter` instead, so a group is kept or dropped as a whole.
            if (d.groupId) {
                var anchor = (_a = d.groupCenter) !== null && _a !== void 0 ? _a : d.center;
                return anchorInPage(anchor.x, anchor.y);
            }
            return anchorInPage(d.center.x, d.center.y);
        });
        widgets.length = 0;
        widgets.push.apply(widgets, keep);
    }
    // Offset texts, tables, annotations, shades, and drawCommands — then filter
    // out any items whose anchor is outside the page (production only).
    // Production-import text adjustments (top-left→center offset by half the box,
    // and the +24px / ×1.1 padding expansion) run ONLY on the initial production
    // load. On the language-switch re-merge (`preserveDimensions`) the text is
    // already processed, and `extractUserSaveState` reverses only the generic
    // scale+diff shift — re-applying these would add half-dimensions on every
    // switch and drift the text diagonally. Share-code data is already final too.
    // `!userWorkspace` for the same reason as the language-switch guard beside it:
    // these are one-time PRODUCTION import adjustments, and text that came back
    // out of `extractUserSaveState` has already had them applied. Re-applying on
    // every load compounds `×1.1 + 24` and shifts the box by half its own size
    // each time, so a text box in user-saved state grows and marches diagonally
    // down-right on every reload.
    var applyProdTextAdjust = !isShareCode && !preserveDimensions && !userWorkspace;
    var texts = ((_68 = activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.texts) !== null && _68 !== void 0 ? _68 : []).map(function (t) {
        var _a, _b;
        // Production JSON dimensions don't account for internal padding (+24px on
        // each axis).  Expand width/height here so the rendered text box matches
        // the authored size.
        var adjLineWidth = applyProdTextAdjust && t.data.lineWidth != null ? t.data.lineWidth * 1.1 + 24 : t.data.lineWidth;
        var adjHeight = applyProdTextAdjust && t.data.height != null ? t.data.height + 24 : t.data.height;
        var rawPos = t.data.position;
        var position = rawPos
            ? __assign(__assign({}, rawPos), { x: (rawPos.x + (applyProdTextAdjust ? ((_a = t.data.lineWidth) !== null && _a !== void 0 ? _a : 0) / 2 : 0)) * scaleX + diffX, y: (rawPos.y + (applyProdTextAdjust ? ((_b = t.data.height) !== null && _b !== void 0 ? _b : 0) / 2 : 0)) * scaleY + diffY }) : rawPos;
        return __assign(__assign({}, t), { data: __assign(__assign(__assign(__assign({}, t.data), { position: position }), (adjLineWidth != null && applyProdTextAdjust ? { lineWidth: adjLineWidth } : {})), (adjHeight != null && applyProdTextAdjust ? { height: adjHeight } : {})) });
    }).filter(function (t) {
        var _a;
        if (!shouldClipToPage)
            return true;
        var p = (_a = t.data) === null || _a === void 0 ? void 0 : _a.position;
        return p ? anchorInPage(p.x, p.y) : true;
    });
    var tables = ((_69 = activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.tables) !== null && _69 !== void 0 ? _69 : []).map(function (t) { return (__assign(__assign({}, t), { data: __assign(__assign({}, t.data), { position: t.data.position ? transformPoint(t.data.position) : t.data.position }) })); }).filter(function (t) {
        var _a;
        if (!shouldClipToPage)
            return true;
        var p = (_a = t.data) === null || _a === void 0 ? void 0 : _a.position;
        return p ? anchorInPage(p.x, p.y) : true;
    });
    var annotations = ((_70 = activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.annotations) !== null && _70 !== void 0 ? _70 : []).map(function (a) {
        var _a;
        return (__assign(__assign({}, a), { data: __assign(__assign({}, a.data), { center: a.data.center ? transformPoint(a.data.center) : a.data.center, points: (_a = a.data.points) === null || _a === void 0 ? void 0 : _a.map(function (p) { return transformPoint(p); }) }) }));
    }).filter(function (a) {
        var _a;
        if (!shouldClipToPage)
            return true;
        var c = (_a = a.data) === null || _a === void 0 ? void 0 : _a.center;
        return c ? anchorInPage(c.x, c.y) : true;
    });
    // Production JSON shades carry no `id` — without a stable, page-unique id
    // here, the WhiteBoard's `shades.map(s => <Shades key={s.id} … />)` ends up
    // with `key={undefined}` for every shade on every page. React then reuses
    // component instances across pages by position, leaking the previous page's
    // local `revealedData` state (the "eye-with-slash" icon showing on page 2's
    // unrevealed cover after revealing page 1's). Mint a stable id here.
    // Shades come entirely from activeWorkspace (no initial config match needed).
    // When a user workspace exists, shades reflect explicit user placement and must
    // not be clipped — the page-bounds filter is only safe for pure production loads
    // where shades were never intentionally repositioned by the user.
    // Redundant now that `shouldClipToPage` carries the same guard (see above),
    // and kept only so this site still reads as deliberate rather than as an
    // oversight if the shared flag is ever loosened again.
    var shouldClipShades = shouldClipToPage && !userWorkspace;
    var shades = ((_71 = activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.shades) !== null && _71 !== void 0 ? _71 : []).map(function (s, idx) {
        var _a;
        return (__assign(__assign({}, s), { id: (_a = s.id) !== null && _a !== void 0 ? _a : "shade_".concat(pageId, "_").concat(idx), data: __assign(__assign({}, s.data), { position: s.data.position ? transformPoint(s.data.position) : s.data.position }) }));
    }).filter(function (s) {
        var _a;
        if (!shouldClipShades)
            return true;
        var p = (_a = s.data) === null || _a === void 0 ? void 0 : _a.position;
        return p ? anchorInPage(p.x, p.y) : true;
    });
    var styleAliasMap = {
        erase: leftSideTools.eraser,
        highlight: leftSideTools.highlighter,
    };
    var drawCommands = ((_72 = activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.drawCommands) !== null && _72 !== void 0 ? _72 : []).map(function (d) {
        var _a, _b;
        return (__assign(__assign({}, d), { style: (_a = styleAliasMap[d.style]) !== null && _a !== void 0 ? _a : d.style, points: (_b = d.points) === null || _b === void 0 ? void 0 : _b.map(function (p) { return __spreadArray([p[0] * scaleX + diffX, p[1] * scaleY + diffY], p.slice(2), true); }) }));
    }).filter(function (d) {
        var _a;
        if (!shouldClipToPage)
            return true;
        // Keep a stroke if at least one of its points falls within the page —
        // a stroke that merely passes through the page boundary should still render.
        if (!((_a = d.points) === null || _a === void 0 ? void 0 : _a.length))
            return true;
        return d.points.some(function (p) { return anchorInPage(p[0], p[1]); });
    });
    // Strict invariant: type === 'numberFrameCounter' ⇒ id starts with 'numberFrameCounter_'.
    // Legacy saves wrote these tokens with the shared `counter_` prefix; rewrite them on
    // load so id-prefix readers see a clean partition. Tray counters (type 'counter') are
    // routed through entities, not widgets, so they never appear here.
    var legacyIdMap = new Map();
    for (var _86 = 0, widgets_3 = widgets; _86 < widgets_3.length; _86++) {
        var w = widgets_3[_86];
        var id = (_73 = w.data) === null || _73 === void 0 ? void 0 : _73.id;
        if (((_74 = w.data) === null || _74 === void 0 ? void 0 : _74.type) === 'numberFrameCounter' && typeof id === 'string' && id.startsWith('counter_')) {
            var newId = 'numberFrameCounter_' + id.slice('counter_'.length);
            legacyIdMap.set(id, newId);
            w.data.id = newId;
        }
    }
    if (legacyIdMap.size > 0) {
        for (var _87 = 0, widgets_4 = widgets; _87 < widgets_4.length; _87++) {
            var w = widgets_4[_87];
            if (((_75 = w.data) === null || _75 === void 0 ? void 0 : _75.type) !== 'numberFrames')
                continue;
            var tokens = w.data.tokens;
            if (!tokens)
                continue;
            for (var _88 = 0, _89 = Object.keys(tokens); _88 < _89.length; _88++) {
                var cell = _89[_88];
                var remapped = legacyIdMap.get(tokens[cell]);
                if (remapped)
                    tokens[cell] = remapped;
            }
        }
    }
    // Repair broken frameId links on numberFrameCounter tokens.
    // When a numberFrames widget was saved without its data.id (id was stripped),
    // the frame gets a new id derived from widgetId on reload — but existing counter
    // tokens still carry the old frameId. Fix by building a reverse map:
    // token widgetId → frame's actual data.id, then update counters whose frameId
    // doesn't match any live frame id.
    var liveFrameIds = new Set(widgets.filter(function (w) { var _a; return ((_a = w.data) === null || _a === void 0 ? void 0 : _a.type) === 'numberFrames'; }).map(function (w) { return w.data.id; }));
    var tokenToFrameId = new Map();
    for (var _90 = 0, widgets_5 = widgets; _90 < widgets_5.length; _90++) {
        var w = widgets_5[_90];
        if (((_76 = w.data) === null || _76 === void 0 ? void 0 : _76.type) !== 'numberFrames')
            continue;
        var frameId = w.data.id;
        var tokens = w.data.tokens;
        if (!tokens)
            continue;
        for (var _91 = 0, _92 = Object.values(tokens); _91 < _92.length; _91++) {
            var tokenWidgetId = _92[_91];
            tokenToFrameId.set(tokenWidgetId, frameId);
        }
    }
    for (var _93 = 0, widgets_6 = widgets; _93 < widgets_6.length; _93++) {
        var w = widgets_6[_93];
        if (((_77 = w.data) === null || _77 === void 0 ? void 0 : _77.type) !== 'numberFrameCounter')
            continue;
        var currentFrameId = w.data.frameId;
        if (currentFrameId && liveFrameIds.has(currentFrameId))
            continue; // already correct
        // frameId is stale — look up the correct frame via the counter's own id
        var correctFrameId = tokenToFrameId.get(w.data.id);
        if (correctFrameId)
            w.data.frameId = correctFrameId;
    }
    return {
        widgets: widgets,
        text: texts,
        table: tables,
        annotations: annotations,
        shades: shades,
        drawCommands: drawCommands,
        background: initialPage === null || initialPage === void 0 ? void 0 : initialPage.background,
        pageId: pageId,
        // Restore the user's saved view zoom (if any). Prefer the user workspace;
        // fall back to prodWorkspace for pure share-code loads where the saved JSON
        // is returned as production with user=null. IDM production baselines never
        // carry userZoom (only extractUserSaveState writes it), so this fallback is
        // safe — it won't accidentally lock an authored activity to a stale zoom.
        zoomLevel: (_78 = userWorkspace === null || userWorkspace === void 0 ? void 0 : userWorkspace.userZoom) !== null && _78 !== void 0 ? _78 : prodWorkspace === null || prodWorkspace === void 0 ? void 0 : prodWorkspace.userZoom,
        bgOffset: {
            diffX: diffX,
            diffY: diffY,
            scaleX: scaleX,
            scaleY: scaleY,
            // pageWidth/pageHeight = the rendered page rectangle (PDF when present,
            // otherwise the workspace dims). PlayerMainContainer's bgPageWidth/Height
            // (production workspace dims, zeroed for IDM) is no longer needed here —
            // the effective rendered dims and the PDF-fit-zoom both use these values.
            pageWidth: effectivePageWidth,
            pageHeight: effectivePageHeight,
            coordWidth: jsonPageWidth,
            coordHeight: jsonPageHeight,
        },
        hideTrayCounter: activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.hideTrayCounter,
        coinsAndCountersDrawer: activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.coinsAndCountersDrawer,
        openPanelSelection: activeWorkspace === null || activeWorkspace === void 0 ? void 0 : activeWorkspace.openPanelSelection,
    };
}
// ─── Per-page transform recalculation ────────────────────────────────────────
//
// Recomputes the (scaleX, scaleY, diffX, diffY) page-to-canvas transform for a
// single page based on:
//   • current canvas size,
//   • per-page workspace dimensions (bgOffset.coordWidth/coordHeight),
//   • current rasterised PDF dimensions (from getPdfPageDimensions).
//
// If the recomputed transform differs from what's currently baked into widget
// positions (tracked via bgOffset.diffX/diffY/scaleX/scaleY), every positional
// field on the page is re-projected:
//   saved = (current_canvas - oldDiff) / oldScale          // undo old transform
//   new_canvas = saved * newScale + newDiff                // apply new transform
// so widgets, text, shades, annotations and draw commands stay aligned with the
// PDF when its size or the workspace dimensions change (e.g. on page navigation
// where each page may have its own PDF aspect).
//
// Returns the same `page` reference unchanged when neither transform nor PDF
// dims have changed.
export function recomputePageDiff(page, canvasSize, isShareCode) {
    if (isShareCode === void 0) { isShareCode = false; }
    if (!(page === null || page === void 0 ? void 0 : page.bgOffset)) {
        return page;
    }
    var _a = page.bgOffset, coordWidth = _a.coordWidth, coordHeight = _a.coordHeight, oldDiffX = _a.diffX, oldDiffY = _a.diffY, oldScaleX = _a.scaleX, oldScaleY = _a.scaleY;
    if (!coordWidth || !coordHeight) {
        return page;
    }
    if (isShareCode) {
        return page;
    }
    var newScaleX = 1;
    var newScaleY = 1;
    var nextPageWidth = coordWidth;
    var nextPageHeight = coordHeight;
    var bg = page.background;
    if (bg && /\.pdf(\?|$)/i.test(bg)) {
        var pdfDims = getPdfPageDimensions(bg);
        if (pdfDims && pdfDims.width > 0 && pdfDims.height > 0) {
            nextPageWidth = pdfDims.width;
            nextPageHeight = pdfDims.height;
        }
    }
    var newDiffX = (canvasSize.canvasWidth - coordWidth) / 2;
    var newDiffY = (canvasSize.canvasHeight - coordHeight) / 2;
    var scaleChanged = Math.abs(newScaleX - oldScaleX) >= 1e-6 || Math.abs(newScaleY - oldScaleY) >= 1e-6;
    var diffChanged = Math.abs(newDiffX - oldDiffX) >= 0.01 || Math.abs(newDiffY - oldDiffY) >= 0.01;
    var dimsChanged = nextPageWidth !== page.bgOffset.pageWidth || nextPageHeight !== page.bgOffset.pageHeight;
    if (!scaleChanged && !diffChanged && !dimsChanged) {
        return page;
    }
    // Transform is unchanged but the cached pageWidth/pageHeight is stale —
    // write them back without touching positions.
    if (!scaleChanged && !diffChanged) {
        return __assign(__assign({}, page), { bgOffset: __assign(__assign({}, page.bgOffset), { pageWidth: nextPageWidth, pageHeight: nextPageHeight }) });
    }
    // Re-project: undo the old transform, then apply the new one.
    var reproject = function (p) {
        var savedX = oldScaleX !== 0 ? (p.x - oldDiffX) / oldScaleX : p.x - oldDiffX;
        var savedY = oldScaleY !== 0 ? (p.y - oldDiffY) / oldScaleY : p.y - oldDiffY;
        return __assign(__assign({}, p), { x: savedX * newScaleX + newDiffX, y: savedY * newScaleY + newDiffY });
    };
    var widgets = page.widgets.map(function (w) {
        var data = w.data;
        var next = __assign({}, data);
        if (data.center)
            next.center = reproject(data.center);
        if (data.groupCenter)
            next.groupCenter = reproject(data.groupCenter);
        if (Array.isArray(data.cards)) {
            next.cards = data.cards.map(function (c) {
                return c.placedOnDeck && c.position ? __assign(__assign({}, c), { position: reproject(c.position) }) : c;
            });
        }
        return __assign(__assign({}, w), { data: next });
    });
    var text = page.text.map(function (t) { return (__assign(__assign({}, t), { data: __assign(__assign({}, t.data), { position: t.data.position ? reproject(t.data.position) : t.data.position }) })); });
    var table = page.table.map(function (t) { return (__assign(__assign({}, t), { data: __assign(__assign({}, t.data), { position: t.data.position ? reproject(t.data.position) : t.data.position }) })); });
    var annotations = page.annotations.map(function (a) {
        var _a;
        return (__assign(__assign({}, a), { data: __assign(__assign({}, a.data), { center: a.data.center ? reproject(a.data.center) : a.data.center, points: (_a = a.data.points) === null || _a === void 0 ? void 0 : _a.map(function (p) { return reproject(p); }) }) }));
    });
    var shades = page.shades.map(function (s) { return (__assign(__assign({}, s), { data: __assign(__assign({}, s.data), { position: s.data.position ? reproject(s.data.position) : s.data.position }) })); });
    var drawCommands = page.drawCommands.map(function (d) {
        var _a;
        return (__assign(__assign({}, d), { points: (_a = d.points) === null || _a === void 0 ? void 0 : _a.map(function (p) {
                var savedX = oldScaleX !== 0 ? (p[0] - oldDiffX) / oldScaleX : p[0] - oldDiffX;
                var savedY = oldScaleY !== 0 ? (p[1] - oldDiffY) / oldScaleY : p[1] - oldDiffY;
                return __spreadArray([savedX * newScaleX + newDiffX, savedY * newScaleY + newDiffY], p.slice(2), true);
            }) }));
    });
    return __assign(__assign({}, page), { widgets: widgets, text: text, table: table, annotations: annotations, shades: shades, drawCommands: drawCommands, bgOffset: __assign(__assign({}, page.bgOffset), { diffX: newDiffX, diffY: newDiffY, scaleX: newScaleX, scaleY: newScaleY, pageWidth: nextPageWidth, pageHeight: nextPageHeight }) });
}
export function buildPagesData() {
    return __awaiter(this, arguments, void 0, function (source, canvasSize, isShareCode, 
    // Fallback language, used only when neither the user save state nor the
    // production baseline carries a saved `appState.language` — see below.
    fallbackLanguage, 
    // True for IDM/SWP activities — gates per-card image sizing + portrait decks.
    isIdmOrSwp) {
        var _a, rawInitial, production, user, savedLanguage, language, initial, safeProduction, baseTrayCounters, cardFrontUrls, sizingUrls, isDeckSaveType, harvestDeckUrls, _i, _b, workspace, _c, _d, widget, _e, _f, pageId, _g, _h, pw, uniqueCardFrontUrls, seenFronts, _j, cardFrontUrls_1, url, pageIds, pagesData;
        var _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
        if (source === void 0) { source = new LocalDataSource(); }
        if (canvasSize === void 0) { canvasSize = {
            canvasWidth: 5000,
            canvasHeight: 5000,
        }; }
        if (isShareCode === void 0) { isShareCode = false; }
        if (fallbackLanguage === void 0) { fallbackLanguage = 'en'; }
        if (isIdmOrSwp === void 0) { isIdmOrSwp = false; }
        return __generator(this, function (_7) {
            switch (_7.label) {
                case 0: return [4 /*yield*/, source.fetchAll()];
                case 1:
                    _a = _7.sent(), rawInitial = _a.initial, production = _a.production, user = _a.user;
                    if (!rawInitial || typeof rawInitial !== 'object' || !('pages' in rawInitial) || !rawInitial.pages) {
                        throw new Error('buildPagesData: initial.pages is missing');
                    }
                    savedLanguage = ((_m = (_l = (_k = user === null || user === void 0 ? void 0 : user.save_state) === null || _k === void 0 ? void 0 : _k.appState) === null || _l === void 0 ? void 0 : _l.language) !== null && _m !== void 0 ? _m : (_p = (_o = production === null || production === void 0 ? void 0 : production.save_state) === null || _o === void 0 ? void 0 : _o.appState) === null || _p === void 0 ? void 0 : _p.language);
                    language = savedLanguage !== null && savedLanguage !== void 0 ? savedLanguage : fallbackLanguage;
                    initial = applyTranslationOverrides(rawInitial, language);
                    safeProduction = ((_q = production === null || production === void 0 ? void 0 : production.save_state) === null || _q === void 0 ? void 0 : _q.workspaces) != null
                        ? production
                        : {
                            save_state: {
                                appState: { saveTime: Math.floor(Date.now() / 1000) },
                                workspaces: Object.keys(initial.pages).map(function () { return ({
                                    drawCommands: [],
                                    shades: [],
                                    texts: [],
                                    annotations: [],
                                    entities: [],
                                    widgets: [],
                                    zoomLevel: 100,
                                }); }),
                            },
                            meta: {
                                appName: 'ida',
                                schemaVersion: 'v1',
                                username: '',
                                activityUUID: (_r = initial.activityId) !== null && _r !== void 0 ? _r : '',
                            },
                        };
                    if (!(Array.isArray(initial.trayCounters) && initial.trayCounters.length > 0)) return [3 /*break*/, 3];
                    baseTrayCounters = rawInitial.trayCounters;
                    console.log('[counter-size] buildPagesData', {
                        language: language,
                        localizedTray: initial.trayCounters.map(function (tc) { return ({ id: tc.counterId, front: tc.frontImage }); }),
                        baseTray: Array.isArray(baseTrayCounters)
                            ? baseTrayCounters.map(function (tc) { return ({ id: tc.counterId, front: tc.frontImage }); })
                            : 'NONE',
                        sameRef: baseTrayCounters === initial.trayCounters,
                    });
                    return [4 /*yield*/, Promise.all([
                            preloadTrayCounterSizes(initial.trayCounters),
                            Array.isArray(baseTrayCounters) && baseTrayCounters.length > 0
                                ? preloadCounterBaseSizes(baseTrayCounters)
                                : Promise.resolve(),
                        ])];
                case 2:
                    _7.sent();
                    _7.label = 3;
                case 3:
                    cardFrontUrls = [];
                    sizingUrls = [];
                    isDeckSaveType = function (t) { return t === 'picker' || t === 'deck' || t === 'deck_pool'; };
                    harvestDeckUrls = function (w) {
                        var _a, _b, _c;
                        var deckImage = (_a = w === null || w === void 0 ? void 0 : w.data) === null || _a === void 0 ? void 0 : _a.deck_image;
                        if (typeof (deckImage === null || deckImage === void 0 ? void 0 : deckImage.frontImage) === 'string')
                            sizingUrls.push(deckImage.frontImage);
                        if (typeof (deckImage === null || deckImage === void 0 ? void 0 : deckImage.primaryImage) === 'string')
                            sizingUrls.push(deckImage.primaryImage);
                        for (var _i = 0, _d = ((_c = (_b = w === null || w === void 0 ? void 0 : w.data) === null || _b === void 0 ? void 0 : _b.cards) !== null && _c !== void 0 ? _c : []); _i < _d.length; _i++) {
                            var card = _d[_i];
                            if (typeof (card === null || card === void 0 ? void 0 : card.frontImage) === 'string') {
                                cardFrontUrls.push(card.frontImage);
                                sizingUrls.push(card.frontImage);
                            }
                            if (typeof (card === null || card === void 0 ? void 0 : card.primaryImage) === 'string') {
                                cardFrontUrls.push(card.primaryImage);
                                sizingUrls.push(card.primaryImage);
                            }
                        }
                    };
                    for (_i = 0, _b = safeProduction.save_state.workspaces; _i < _b.length; _i++) {
                        workspace = _b[_i];
                        for (_c = 0, _d = (_s = workspace.widgets) !== null && _s !== void 0 ? _s : []; _c < _d.length; _c++) {
                            widget = _d[_c];
                            if (!isDeckSaveType(widget === null || widget === void 0 ? void 0 : widget.type))
                                continue;
                            harvestDeckUrls(widget);
                        }
                    }
                    for (_e = 0, _f = Object.keys(initial.pages); _e < _f.length; _e++) {
                        pageId = _f[_e];
                        for (_g = 0, _h = (_u = (_t = initial.pages[pageId]) === null || _t === void 0 ? void 0 : _t.pageWidgets) !== null && _u !== void 0 ? _u : []; _g < _h.length; _g++) {
                            pw = _h[_g];
                            if (!isDeckSaveType(pw === null || pw === void 0 ? void 0 : pw.type))
                                continue;
                            harvestDeckUrls(pw);
                        }
                    }
                    if (!(sizingUrls.length > 0)) return [3 /*break*/, 5];
                    return [4 /*yield*/, preloadImageSizes(sizingUrls)];
                case 4:
                    _7.sent();
                    _7.label = 5;
                case 5:
                    uniqueCardFrontUrls = [];
                    seenFronts = new Set();
                    for (_j = 0, cardFrontUrls_1 = cardFrontUrls; _j < cardFrontUrls_1.length; _j++) {
                        url = cardFrontUrls_1[_j];
                        if (seenFronts.has(url))
                            continue;
                        seenFronts.add(url);
                        uniqueCardFrontUrls.push(url);
                    }
                    uniqueCardFrontUrls.forEach(function (url) {
                        preloadAsBlob(url).catch(function () { return undefined; });
                    });
                    pageIds = Object.keys(initial.pages);
                    pagesData = pageIds.map(function (pageId, index) {
                        return mergePageData(initial, safeProduction, user, pageId, index, canvasSize, isShareCode, false, isIdmOrSwp);
                    });
                    return [2 /*return*/, {
                            pagesData: pagesData,
                            productionBaseline: safeProduction,
                            manipulativeBtnState: (_0 = (_x = (_w = (_v = user === null || user === void 0 ? void 0 : user.save_state) === null || _v === void 0 ? void 0 : _v.appState) === null || _w === void 0 ? void 0 : _w.manipulativeBtnState) !== null && _x !== void 0 ? _x : (_z = (_y = production === null || production === void 0 ? void 0 : production.save_state) === null || _y === void 0 ? void 0 : _y.appState) === null || _z === void 0 ? void 0 : _z.manipulativeBtnState) !== null && _0 !== void 0 ? _0 : null,
                            playerBgPattern: (_6 = (_3 = (_2 = (_1 = user === null || user === void 0 ? void 0 : user.save_state) === null || _1 === void 0 ? void 0 : _1.appState) === null || _2 === void 0 ? void 0 : _2.playerBgPattern) !== null && _3 !== void 0 ? _3 : (_5 = (_4 = production === null || production === void 0 ? void 0 : production.save_state) === null || _4 === void 0 ? void 0 : _4.appState) === null || _5 === void 0 ? void 0 : _5.playerBgPattern) !== null && _6 !== void 0 ? _6 : null,
                            language: language,
                            activityMeta: {
                                title: initial.title,
                                activityId: initial.activityId,
                                trayCounters: initial.trayCounters,
                                translations: initial.translations,
                            },
                        }];
            }
        });
    });
}
// ─── Extract user save state (for sending to server) ───
export function extractUserSaveState(currentPageData, productionBaseline, userMeta, manipulativeBtnState, playerBgPattern, language) {
    if (manipulativeBtnState === void 0) { manipulativeBtnState = null; }
    if (playerBgPattern === void 0) { playerBgPattern = null; }
    if (language === void 0) { language = null; }
    var workspaces = currentPageData.map(function (page, index) {
        var _a, _b, _c, _d, _e;
        // Production baseline is null for fresh non-IDM activities (the
        // `loadActivityData` thunk short-circuits when there's no IDM context
        // and no share code). We still need a save state for the live pageData,
        // so fall back to an undefined baseWorkspace and use safe defaults.
        var baseWorkspace = (_b = (_a = productionBaseline === null || productionBaseline === void 0 ? void 0 : productionBaseline.save_state) === null || _a === void 0 ? void 0 : _a.workspaces) === null || _b === void 0 ? void 0 : _b[index];
        // Runtime `data.center` is in canvas-coords (post merge transform). Save in
        // workspace coords by inverting the transform:
        //   saved = (canvas − diff) / scale
        // and persist the original workspace dimensions alongside so any reload can
        // re-derive the same scale/diff and render at the same visual size.
        var offset = (_c = page.bgOffset) !== null && _c !== void 0 ? _c : { diffX: 0, diffY: 0, scaleX: 1, scaleY: 1, pageWidth: 0, pageHeight: 0, coordWidth: 0, coordHeight: 0 };
        var diffX = offset.diffX, diffY = offset.diffY, _f = offset.scaleX, scaleX = _f === void 0 ? 1 : _f, _g = offset.scaleY, scaleY = _g === void 0 ? 1 : _g, coordWidth = offset.coordWidth, coordHeight = offset.coordHeight;
        var isIdentity = diffX === 0 && diffY === 0 && Math.abs(scaleX - 1) < 1e-9 && Math.abs(scaleY - 1) < 1e-9;
        var safeSx = scaleX !== 0 ? scaleX : 1;
        var safeSy = scaleY !== 0 ? scaleY : 1;
        var unShiftPoint = function (p) { return ({
            x: (p.x - diffX) / safeSx,
            y: (p.y - diffY) / safeSy,
        }); };
        var unShiftManipulative = function (m) {
            if (isIdentity)
                return m;
            var data = m.data;
            var next = __assign({}, data);
            if (data.center)
                next.center = unShiftPoint(data.center);
            if (data.groupCenter)
                next.groupCenter = unShiftPoint(data.groupCenter);
            // Decks dealt onto the canvas carry per-card absolute positions.
            if (Array.isArray(data.cards)) {
                next.cards = data.cards.map(function (c) {
                    return c.placedOnDeck && c.position ? __assign(__assign({}, c), { position: unShiftPoint(c.position) }) : c;
                });
            }
            return __assign(__assign({}, m), { data: next });
        };
        // Separate counters (entities) from page-level widgets
        var pageWidgets = [];
        var entities = [];
        for (var _i = 0, _h = page.widgets; _i < _h.length; _i++) {
            var m = _h[_i];
            var unshifted = unShiftManipulative(m);
            if (m.type === 'counter') {
                if (!m.data.customImage)
                    continue;
                entities.push(manipulativeToEntity(unshifted));
            }
            else {
                pageWidgets.push(manipulativeToSaveWidget(unshifted));
            }
        }
        var unShiftAnnotation = function (a) {
            var _a;
            if (isIdentity)
                return a;
            return __assign(__assign({}, a), { data: __assign(__assign({}, a.data), { center: a.data.center ? unShiftPoint(a.data.center) : a.data.center, points: (_a = a.data.points) === null || _a === void 0 ? void 0 : _a.map(function (p) { return (__assign(__assign({}, p), unShiftPoint(p))); }) }) });
        };
        var unShiftText = function (tt) {
            if (isIdentity)
                return tt;
            return __assign(__assign({}, tt), { data: __assign(__assign({}, tt.data), { position: tt.data.position
                        ? __assign(__assign({}, tt.data.position), unShiftPoint(tt.data.position)) : tt.data.position }) });
        };
        var unShiftShade = function (s) {
            if (isIdentity)
                return s;
            return __assign(__assign({}, s), { data: __assign(__assign({}, s.data), { position: s.data.position
                        ? __assign(__assign({}, s.data.position), unShiftPoint(s.data.position)) : s.data.position }) });
        };
        var unShiftTable = function (t) {
            if (isIdentity)
                return t;
            return __assign(__assign({}, t), { data: __assign(__assign({}, t.data), { position: t.data.position
                        ? __assign(__assign({}, t.data.position), unShiftPoint(t.data.position)) : t.data.position }) });
        };
        var unShiftDrawCommand = function (d) {
            var _a;
            if (isIdentity)
                return d;
            return __assign(__assign({}, d), { points: (_a = d.points) === null || _a === void 0 ? void 0 : _a.map(function (p) {
                    var u = unShiftPoint({ x: p[0], y: p[1] });
                    return __spreadArray([u.x, u.y], p.slice(2), true);
                }) });
        };
        return __assign(__assign(__assign(__assign(__assign({ drawCommands: page.drawCommands.map(unShiftDrawCommand), shades: page.shades.map(unShiftShade), texts: page.text.map(unShiftText), tables: page.table.map(unShiftTable), annotations: page.annotations.map(unShiftAnnotation), entities: entities, widgets: pageWidgets, zoomLevel: (_d = baseWorkspace === null || baseWorkspace === void 0 ? void 0 : baseWorkspace.zoomLevel) !== null && _d !== void 0 ? _d : 100 }, (page.hideTrayCounter != null ? { hideTrayCounter: page.hideTrayCounter } : {})), (((_e = page.coinsAndCountersDrawer) === null || _e === void 0 ? void 0 : _e.length)
            ? { coinsAndCountersDrawer: page.coinsAndCountersDrawer }
            : {})), (page.zoomLevel != null ? { userZoom: page.zoomLevel } : {})), (page.openPanelSelection ? { openPanelSelection: page.openPanelSelection } : {})), (coordWidth && coordHeight ? { dimensions: { width: coordWidth, height: coordHeight } } : {}));
    });
    return {
        save_state: {
            appState: __assign(__assign({ saveTime: Math.floor(Date.now() / 1000), manipulativeBtnState: manipulativeBtnState }, (playerBgPattern && { playerBgPattern: playerBgPattern })), (language && { language: language })),
            workspaces: workspaces,
        },
        meta: __assign({ appName: 'ida', schemaVersion: 'v1' }, userMeta),
    };
}
